'use client';

/**
 * StaticGradientBackground Component
 * ===================================
 *
 * A lightweight static gradient fallback for LiquidEther.
 * Used on low-end devices where WebGL fluid simulation is too heavy.
 *
 * Features:
 * - Pure CSS gradient (no JS animation)
 * - Optional subtle CSS animation (can be disabled)
 * - Matches LiquidEther color scheme
 * - Zero performance impact
 */

interface StaticGradientBackgroundProps {
  colors?: string[];
  animate?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

export default function StaticGradientBackground({
  colors = ['#5227FF', '#FF9FFC', '#B19EEF'],
  animate = false,
  className = '',
  style = {},
}: StaticGradientBackgroundProps) {
  // Create gradient stops
  const gradientStops = colors.map((color, i) => {
    const percent = (i / (colors.length - 1)) * 100;
    return `${color} ${percent}%`;
  }).join(', ');

  return (
    <div
      className={`static-gradient-bg ${animate ? 'static-gradient-animate' : ''} ${className}`}
      style={{
        position: 'absolute',
        inset: 0,
        background: `linear-gradient(135deg, ${gradientStops})`,
        opacity: 0.6,
        ...style,
      }}
    />
  );
}
